import { MFALockout } from '@organization/api/requests'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTableColumns } from './tableColumns'
import { LockoutActions, LockoutActionsTypes } from '../LockoutActions'
import { getActionColumnMenu } from './tableActions'

type Props = {
  data?: MFALockout[]
  triggerSort: (sorter: SorterResult<MFALockout>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<MFALockout>
  ) => TableColumnsType<MFALockout>
} & TableProps<MFALockout>

export const LockoutsTable = ({
  data,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const [modal, setModal] = useState<{
    type: LockoutActionsTypes
    data: MFALockout
  } | null>(null)

  const columns = getSortedTableColumns(
    getTableColumns(getActionColumnMenu(setModal, t), t)
  )

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        scroll={{ x: 'auto' }}
        onChange={(_, __, sorter) =>
          triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
        }
        {...props}
      />

      {modal && (
        <LockoutActions
          open
          onCancel={() => setModal(null)}
          onSuccess={() => setModal(null)}
          {...modal}
        />
      )}
    </>
  )
}
